import { useEffect, useState, useRef } from 'react';
import './Confetti.css';

const PARTICLE_COUNT = 12;
const COLORS = ['#d4d4d4', '#e8e8e8', '#c0c0c0', '#f0f0f0', '#b8b8b8', '#ffffff'];

function Confetti({ trigger, originRef }) {
  const [particles, setParticles] = useState([]);
  const lastTriggerRef = useRef(null);

  useEffect(() => {
    // Only fire if this is a new trigger we haven't processed yet
    if (trigger && trigger !== lastTriggerRef.current && originRef?.current) {
      lastTriggerRef.current = trigger;

      const rect = originRef.current.getBoundingClientRect();
      const originX = rect.left + rect.width / 2;
      const originY = rect.top + rect.height / 2;

      const newParticles = Array.from({ length: PARTICLE_COUNT }, (_, i) => {
        const angle = (Math.PI * 2 * i) / PARTICLE_COUNT + (Math.random() - 0.5) * 0.5;
        const velocity = 120 + Math.random() * 80;
        const size = 4 + Math.random() * 4;

        return {
          id: Date.now() + i,
          x: originX,
          y: originY,
          vx: Math.cos(angle) * velocity,
          vy: Math.sin(angle) * velocity,
          size,
          color: COLORS[Math.floor(Math.random() * COLORS.length)],
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 15,
        };
      });

      setParticles(newParticles);

      // Clear particles after animation
      const timer = setTimeout(() => {
        setParticles([]);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [trigger, originRef]);

  if (particles.length === 0) return null;

  return (
    <div className="confetti-container">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="confetti-particle"
          style={{
            '--start-x': `${particle.x}px`,
            '--start-y': `${particle.y}px`,
            '--vx': `${particle.vx}px`,
            '--vy': `${particle.vy}px`,
            '--size': `${particle.size}px`,
            '--rotation': `${particle.rotation}deg`,
            '--rotation-speed': `${particle.rotationSpeed}deg`,
            backgroundColor: particle.color,
          }}
        />
      ))}
    </div>
  );
}

export default Confetti;
